import { Listing } from './listing.type';

export const getBadgeValues = (listing: Listing) => {
    const values: string[] = [];

    listing.tags?.forEach((tag) => {
        if (tag?.content) {
            values.push(tag.content);
        }
    });

    return values;
};
